jQuery(document).ready(function () {

  bindAddressLookups = function () {

    var addressLookUpToken = jQuery('#loqateAccessToken');
    var addressLookUps = jQuery('form.form-postcodelookup');

    if (addressLookUpToken !== undefined &&
      addressLookUpToken !== null &&
      addressLookUpToken.val() !== null &&
      addressLookUps !== undefined &&
      addressLookUps !== null &&
      addressLookUps.length > 0) {

      addressLookUps.each(function () {

        var id_SearchField = "";
        if ($(this).find('.postcodelookup-search') !== undefined) {
          id_SearchField = $(this).find('.postcodelookup-search').attr('id');
        }

        var id_TownField = "";
        if ($(this).find('.postcodelookup-town') !== undefined) {
          id_TownField = $(this).find('.postcodelookup-town').attr('id');
        }

        var id_CountyField = "";
        if ($(this).find('.postcodelookup-county') !== undefined) {
          id_CountyField = $(this).find('.postcodelookup-county').attr('id');
        }

        var id_PostCode = "";
        if ($(this).find('.postcodelookup-postcode') !== undefined) {
          id_PostCode = $(this).find('.postcodelookup-postcode').attr('id');
        }

        var id_CountryField = "";
        if ($(this).find('.postcodelookup-country') !== undefined) {
          id_CountryField = $(this).find('.postcodelookup-country').attr('id');
        }

        var id_AddressLine1Field = "";
        if ($(this).find('.postcodelookup-addr_line_1') !== undefined) {
          id_AddressLine1Field = $(this).find('.postcodelookup-addr_line_1').attr('id');
        }

        var id_AddressLine2Field = "";
        if ($(this).find('.postcodelookup-addr_line_2') !== undefined) {
          id_AddressLine2Field = $(this).find('.postcodelookup-addr_line_2').attr('id');
        }

        var id_AddressLine3Field = "";
        if ($(this).find('.postcodelookup-addr_line_3') !== undefined) {
          id_AddressLine3Field = $(this).find('.postcodelookup-addr_line_3').attr('id');
        }

        var fields = [
          { element: "search", field: "" },
          { element: id_AddressLine1Field, field: "Line1", mode: pca.fieldMode.POPULATE },
          { element: id_AddressLine2Field, field: "Line2", mode: pca.fieldMode.POPULATE },
          { element: id_AddressLine3Field, field: "Line3", mode: pca.fieldMode.POPULATE },
          { element: id_TownField, field: "City", mode: pca.fieldMode.POPULATE },
          { element: id_CountyField, field: "Province", mode: pca.fieldMode.POPULATE },
          { element: id_PostCode, field: "PostalCode" },
          { element: id_CountryField, field: "CountryName", mode: pca.fieldMode.COUNTRY }
        ];

        var options = { key: addressLookUpToken.val() };

        var control = new pca.Address(fields, options);

        control.listen("populate", function (address, variations) {
        });

        control.load();

      });
    }
  };

  //loqate
  (function (pca) {
    if (!pca) {
      return;
    }

    pca.on("ready", function () {
      bindAddressLookups();
    });

    pca.on("options", function (type, id, options) {
      options.setCountryByIP = false;
      options.countries.populate = false;
      options.countries.prepopulate = false;
    });

    pca.on("load", function (type, id, control) {
      var isChrome = !!window.chrome && !!window.chrome.webstore;
      if (isChrome === true) {
        for (i = 0; control.fields.length > i; i++) {
          var elem = document.getElementById(control.fields[i].element);
          if (elem) {
            document.getElementById(control.fields[i].element).autocomplete = "PCATEST";
          }
          else {
            console.log(control.fields[i].element);
          }

          $(".pca-test-autocomplete").each(function () {
            $(this).attr("autocomplete", "PCATEST");
          });

        };
      };
    });
  }(window.pca));

});
